import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { useCartIsOpen } from '@/app/cart/useCartIsOpen';

import CartSheet from '@/app/cart/CartSheet';
import Mark from '@/components/common/Mark';

const Header = ({ title, backTo }) => {
  const { openCart } = useCartIsOpen();
  const navigate = useNavigate();
  return (
    <>
      <div className="fixed top-0 left-0 right-0 backdrop-blur-sm border-b py-4 px-4 flex flex-col z-50">
        <div className="flex items-center justify-between">
          {!backTo && <div className="w-10" />}
          {backTo && (
            <ChevronLeft
              className="w-10 h-10 cursor-pointer -my-2"
              onClick={() => navigate(backTo)}
            />
          )}
          <Mark onClick={() => openCart()} />
          <CartSheet />
        </div>
        <div>
          <h1 className="text-xl font-bold absolute left-1/2 -translate-x-1/2 bottom-2">
            {title}
          </h1>
        </div>
      </div>
      <div className="h-[64px]"></div>
    </>
  );
};

export default Header;
